import { render, staticRenderFns } from "./NotificationsSideBar.vue?vue&type=template&id=7c537051"
import script from "./NotificationsSideBar.vue?vue&type=script&lang=js"
export * from "./NotificationsSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports